var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("DropdownFilter", {
    attrs: {
      value: _vm.value,
      options: _vm.cityOptions,
      customMultiStyleParent: _vm.getcontainerStyle,
      loading: _vm.$apollo.queries.projectCities.loading,
      placeholder: _vm.placeholder,
    },
    on: { search: _vm.handleSearch, input: _vm.handleInput },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }